import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isDateAfterToday(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!!control?.value === false) {
      return null;
    }
    const TODAY = new Date();
    TODAY.setHours(0, 0, 0, 0);
    const [THIS_YEAR, THIS_MONTH, THIS_DATE] = control.value.split('-');
    const THE_DATE = new Date(`${THIS_MONTH}/${THIS_DATE}/${THIS_YEAR}`);
    if (THE_DATE.getTime() <= TODAY.getTime()) {
      return {
        dateAfterToday: {
          valid: false
        }
      };
    }
    return null;
  };
}
